import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import WizardStateContext from 'components/Wizards/shared/context/wizardstate';
import Switch from 'components/Kizen/Switch';
import {
  DashboardStyleSettingsProvider,
  DashboardStyleSettings,
  DEFAULT_DASHLET_STYLE_SETTINGS,
} from 'ts-components/StyleSettings';
import { StyledWizardField } from 'components/Wizards/shared/styles';

const StyleDisplaySettings = () => {
  const { t } = useTranslation();
  const { state, setState } = useContext(WizardStateContext.Context);
  const { dashletStyleConfig } = state;
  return (
    <>
      <StyledWizardField fullWidth top={20}>
        <Switch
          data-qa="custom-styles"
          checked={
            dashletStyleConfig && Object.keys(dashletStyleConfig).length > 0
          }
          textPlacement="regular-top"
          label={t('Customize Styles')}
          onClick={(event) => {
            if (event.target.checked) {
              setState('dashletStyleConfig', DEFAULT_DASHLET_STYLE_SETTINGS);
            } else {
              setState('dashletStyleConfig', undefined);
            }
          }}
        />
      </StyledWizardField>
      {dashletStyleConfig && Object.keys(dashletStyleConfig).length > 0 ? (
        <DashboardStyleSettingsProvider styleSettings={dashletStyleConfig}>
          <DashboardStyleSettings
            onChange={(settings) => setState('dashletStyleConfig', settings)}
          />
        </DashboardStyleSettingsProvider>
      ) : null}
    </>
  );
};

export default StyleDisplaySettings;
